import i18n from '@/i18n';
import vuetify from '@/plugins/vuetify';
import httpClient from '@/api';
import mediaServerHttpClient from '@/mediaServerHttpClient';
import InterviewPreset from '@/orm/models/Interview/InterviewPreset';
import Interviewer from '@/orm/models/Interview/Interviewer';
import VacancyFaqCommon from '@/orm/models/Vacancy/VacancyFaqCommon';

export default {
  change(locale) {
    i18n.locale = locale;
    vuetify.framework.lang.current = locale;
    httpClient.defaults.headers.common['Accept-Language'] = locale;
    mediaServerHttpClient.defaults.headers.common['Accept-Language'] = locale;
    localStorage.setItem('locale', locale);
    InterviewPreset.deleteAll();
    Interviewer.deleteAll();
    VacancyFaqCommon.deleteAll();
  },
};
